import React from "react"
import { useDashboardStore } from "features/Dashboard/runtime/dashboardStore"
import { NET_HINT } from "./inspectorCopy"

/**
 * Under every way of building a net: what a net assumes, and where the
 * pipeline with an "any of" variable is applied, with a link that opens
 * the Data panel.
 */
const NetHint: React.FC = () => {
  const openDataPanel = useDashboardStore((s) => s.setDataPanelOpen)
  return (
    <p className="dq-field__hint">
      {NET_HINT} Then add its pipeline in the{" "}
      <button
        type="button"
        className="dq-hint-link"
        onClick={() => openDataPanel(true)}
      >
        Data panel
      </button>
      .
    </p>
  )
}

export default NetHint
